import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/app/auth-o3/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ImportProductService {
  constructor(private apiService: ApiService) {}

  processFile(
    type: 'text/xml' | 'text/csv' | 'application/json',
    content: string
  ): Observable<any> {
    return this.apiService
      .postWithHeaders('import', content, environment.api.productData, {
        'Content-Type': type,
      })
      .pipe(first());
  }

  updateFile(
    type: 'text/xml' | 'application/json',
    productId: number,
    content: string
  ): Observable<any> {
    return this.apiService
      .putWithHeaders(`${productId}`, content, environment.api.productData, {
        'Content-Type': type,
      })
      .pipe(first());
  }
}
